import { MUITab } from "@abb/arcadia-ui-react"
import { useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../services/api"
import {
  DiMaDetailsHeader,
  DiMaDetailsHeaderProps,
} from "../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../components/DiMaProgress"
import { NotificationGet } from "../../../models/Notification"
import { useHashTab } from "../../../../hooks/useHashTab"
import { NotificationDetails } from "./details_tab/NotificationDetails"

const returnURL = "/notifications"

export function NotificationContainer() {
  const { notificationId } = useParams()
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")

  const [notification, setNotification] = useState<NotificationGet>()

  useEffect(() => {
    if (notificationId) {
      digitalManagerApi
        .get<NotificationGet>(`/notifications/${notificationId}`)
        .then((res) => {
          setNotification(res.data)
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [navigate, notificationId])

  if (!notificationId) {
    return <Navigate to={returnURL} />
  }

  if (!notification) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: notification.title,
    label: "Application",
    subtitle: notification.application.name,
    hideCopyToClipboard: true,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <DiMaDetailsHeader {...detailsHeaderProps} />
      <MUITab
        tabItems={[{ id: "details", label: "Details" }]}
        value={activeTab}
        handleChange={handleTabChange}
      />
      {activeTab === "details" && (
        <NotificationDetails
          notification={notification}
          setNotification={setNotification}
        />
      )}
    </div>
  )
}
